var url = require('url');
var https = require('https');

var jquery = require("jquery");
window.$ = window.jQuery = jquery; // notice the definition of global variables here

class WFS{
	data(type,input={},callback,callback2){
	
		var that = this;
		var date = new Date();
		var year = date.getFullYear();
		var exportdata;
		let urlSett = {};
		
		// default query
		var query = {
				CRS: 	'epsg:3857',
				//TIME:	year+'-04-01/'+year+'-10-01',
				BBOX: '1440000,5745000,1540000,5770000',
				//BBOX:	'1516510,5769466,1516511,5769465',
				//RESOLUTION:	10,
				MAXCC:	70,	// max cloude coverage
				//BINS:	100,
				SERVICE: 'WFS',
				REQUEST: 'GetFeature',
				VERSION: '2.0.0',
				TYPENAMES: "DSS1",
				//TYPENAME: "DSS6",
				outputFormat: "application/json",
			};
			
		// input can overwrite default
		const merge = Object.assign(query, input);
		
		if(query.TYPENAME != "DSS6"){
			urlSett = {
				protocol: 'https',
				hostname: 'services.sentinel-hub.com',
				pathname: '/ogc/wfs/b0e40866-277e-4f53-84e6-ccc6a01aa3c3',
				query: merge
			};
		}else{
			urlSett ={
				protocol: 'https',
				hostname: 'services-uswest2.sentinel-hub.com',
				pathname: '/ogc/wfs/b0e40866-277e-4f53-84e6-ccc6a01aa3c3',
				query: merge
			};
		}
		
		const requestUrl = url.parse(url.format(urlSett));
		
		// TODO - replace listener with callback for "WMS_slider"
		const req = https.get({
					hostname: requestUrl.hostname,
					path: requestUrl.path,
				}, (res) => {
					
					let chunk_data = "";
					
					res.on('data', function (chunk) {
							chunk_data += chunk;
					  });
					  
					res.on("end", function(){
						
						exportdata = JSON.parse(chunk_data);
						
						if(type == "WFS_slider"){
							exportdata = that.constructor.extractDates(exportdata);
							
							if(callback) callback(exportdata);
							if(callback2) callback2(exportdata);
						}
						/*
						$(document).trigger(type, [exportdata]);
						
						if(type == "WFS_point"){		
							if(callback) callback(exportdata);
						}
						*/
					});
				});
	}
					
	static extractDates(data){
		var objekt;
		var dates = [];
		if(data.hasOwnProperty("features")){		
			objekt = data["features"];
		}else{	// empty data case
			return [];
		}
			
		objekt.forEach(function(subject){
			dates.push(subject.properties.date);
		});
		
		let uniqueNames = [];
		$.each(dates, function(i, el){
			if($.inArray(el, uniqueNames) === -1) uniqueNames.push(el);
		});
		
		return uniqueNames;
	}
}
		
export {WFS};